import { client } from "@/api/client.ts";
import { USER_BASE_URL } from "./internal-const.ts";

export const getStripeSession = async (priceId: string) => {
  return await client
    .post(`${USER_BASE_URL}/api/stripe-checkout`, {
      PriceID: priceId,
    })
    .then((data) => data.data);
};

export const grantFreeOffer = async (sourceProductId: string) => {
  return await client
    .post(`${USER_BASE_URL}/api/free-product-access`, {
      SourceProductID: sourceProductId,
    })
    .then((data) => data.data);
};

interface CancelExternalSubscriptionRequest {
  old_platform: string;
}

export const cancelExternalSubscription = async (
  payload: CancelExternalSubscriptionRequest,
) => {
  return await client
    .post(`${USER_BASE_URL}/api/revoke-migrated-access`, payload)
    .then((data) => data.data);
};

export const getResubscribeURL = async () => {
  return await client
    .post(`${USER_BASE_URL}/api/stripe-resubscribe`)
    .then((data) => data.data.url);
};
